import Crud from '../components/Company/Crud'
import Entity from '../components/Company/Add'

let routes = {
    path: '/companies',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/companies/add',
            name: 'Nova Empresa',
            component: Entity
        },
        {
            path: '/companies/edit/:id?',
            name: 'Editar Empresa',
            component: Entity
        },
        {
            path: '/companies',
            name: 'Empresas',
            component: Crud
        },
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/company.js